import React from 'react';
import { translate } from 'react-i18next';

import {colors, spacings, fontSizes, layout, fonts} from 'style';
import LoadInline from '../loading/LoadInline.js';
import PluginItem from './PluginItem.js';

import './plugins.css';

var s = {
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeDarkerGrey,
        position:'relative',
    },
    group: {
        paddingTop: spacings.small,
        paddingBottom: spacings.small,
        paddingLeft: '0px',
        paddingRight: '0px',
        marginTop: '0',
    },
    partition: {
        height: '28px',
        lineHeight: '28px',
        paddingLeft: spacings.small,
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
        color: colors.themeDarkGrey,
        width: '100%',
    },
    body: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
        paddingTop: spacings.small,
        minHeight: '100%',
    },
};

const Plugins = ({t, children, connectedPlugins, disconnectedPlugins, loadingData, connect, disconnect, isDeadLink, imageLoadError, style, bodyStyle}) => (
    <div className="full-height scrollable" style={{...s.content, ...style}}>
            <div style={{...s.body, ...bodyStyle}}>
            {children}
            {loadingData && 
                <LoadInline centered vcentered /> 
            }
            {!loadingData && 
            <div>
                {connectedPlugins.length>0 &&
                <div>
                    <div style={s.partition}>{t('Connected')}</div>
                    <div style={s.group}>
                        {connectedPlugins.map((plugin)=>(
                            <PluginItem key={plugin.id}
                                        plugin={plugin} 
                                        connect={connect} 
                                        disconnect={disconnect}
                                        isDeadLink={isDeadLink}
                                        imageLoadError={imageLoadError} />
                        ))}   
                    </div>
                </div>
                }
                {disconnectedPlugins.length>0 &&
                <div>
                    <div style={s.partition}>{t('Available')}</div>
                    <div style={s.group}>
                        {disconnectedPlugins.map((plugin)=>(
                            <PluginItem key={plugin.id}
                                        plugin={plugin} 
                                        connect={connect} 
                                        disconnect={disconnect}
                                        isDeadLink={isDeadLink}
                                        imageLoadError={imageLoadError} />
                        ))}   
                    </div>
                </div>
                }
            </div>
            }
        </div>
    </div>
);

export default translate('plugins')(Plugins);



// WEBPACK FOOTER //
// ./src/modules/plugins/Plugins.js